import definition from './things.service';

/**
 * ThingsService settings
 * @type {{name: string, definition: ThingsService}}
 */
const Service = {
    name: 'ThingsService',
    definition
};

export {
    Service
};



// WEBPACK FOOTER //
// ./app/services/things/index.js